"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/stores/useAuthStore";

export default function Page() {
  const router = useRouter();

  const { user: currentUser, isAdmin } = useAuthStore();

  useEffect(() => {
    if (!currentUser) {
      router.push("/login");
    } else {
      if (isAdmin) {
        router.push("/users");
      } else {
        router.push("/device");
      }
    }
  }, [currentUser]);
}
